module.exports = __webpack_public_path__ + "static/Busfinder_Kreis_100.png";